export default function CMemoryManagement() {
  return <h2>C Memory Management</h2>;
}
